import {
  legacyCasesService,
  LegacyCaseRequestError,
} from "../services/legacyCases.service";
import type { LegacyCaseDetail } from "../types/legacyCases";

export interface PreparedLegacyCase extends LegacyCaseDetail {
  preparationError?: string;
}

export async function prepareLegacyReview(
  id: string
): Promise<PreparedLegacyCase> {
  const detail = await legacyCasesService.get(id);
  const reports = detail.documents.filter(
    (document) => document.kind === "report"
  );
  if (
    detail.latestReview ||
    detail.importedCaseId ||
    reports.length !== 1 ||
    detail.extractions.some(
      (extraction) =>
        extraction.documentId === reports[0].id &&
        (!detail.currentParserVersion ||
          (extraction.result.parserVersion === detail.currentParserVersion &&
            extraction.result.sourceSha256 === reports[0].sha256))
    )
  )
    return detail;
  try {
    return await legacyCasesService.prepare(id);
  } catch (error) {
    if (
      error instanceof LegacyCaseRequestError &&
      error.code === "case_number_exists"
    )
      return detail;
    return {
      ...detail,
      preparationError:
        "Automatic report extraction could not finish. The original PDF is available below. Retry with Extract report text, or continue reviewing manually; your draft is retained.",
    };
  }
}
